export default __webpack_public_path__ + "static/media/avatar_basica.afbb011a.png";